import * as React from "react"
import { Link, navigate } from "gatsby";
import { LocaleLink } from "../lib/IntlTools";

export default function Index() {
  if (typeof window !== "undefined") {
    navigate(LocaleLink("/ncd/"));
  }

  return (
    <></>
  );
}
